import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './style.module.scss'
import navigatePrevSVG from 'assets/images/navigation-prev-24.svg'
import navigateNextSVG from 'assets/images/navigation-next-24.svg'
import moment from 'moment'
import classNames from 'classnames'

type PickerType = 'calendar' | 'todo'

interface MonthPickerProps {
  focusedMonth?: Date
  showToday?: boolean
  inYear?: number
  onMonthClick?: (date: Date) => void
  onTodayClick?: () => void
  pickerType?: PickerType
}

const MonthPicker: React.FC<MonthPickerProps> = ({
  focusedMonth = new Date(),
  showToday = false,
  inYear = focusedMonth.getFullYear(),
  onMonthClick = () => {},
  onTodayClick = () => {},
  pickerType = 'calendar',
}) => {
  const today = new Date()
  const months: string[] = []
  const m = moment()
  const isTodoPicker = pickerType === 'todo'

  const { t } = useTranslation()

  for (let i = 0; i < 12; i++) {
    m.month(i)
    months.push(m.format('MMM'))
  }

  const isToday = (monthIndex: number): boolean => {
    return today.getFullYear() === inYear && today.getMonth() === monthIndex
  }

  const isFocused = (monthIndex: number): boolean => {
    return monthIndex === focusedMonth.getMonth() && inYear === focusedMonth.getFullYear()
  }

  const handlePrevClick = (): void => {
    // setInYear(inYear - 1)
  }

  const handleNextClick = (): void => {
    // setInYear(inYear + 1)
  }

  const handleMonthClick = (index: number): void => {
    const newDate = new Date(inYear, index, 1)
    const today = new Date()
    if (newDate.getFullYear() === today.getFullYear() && newDate.getMonth() === today.getMonth()) {
      onMonthClick(today)
    } else {
      onMonthClick(newDate)
    }
  }

  return (
    <div className={classNames(styles.container, isTodoPicker ? styles.todoPickerContainer : '')}>
      <div className={styles.header}>
        <span className={styles.year}>{inYear}</span>
        <div className={styles.navigation}>
          <button onClick={handlePrevClick}>
            <img src={navigatePrevSVG} alt="prev" />
          </button>
          <button onClick={handleNextClick}>
            <img src={navigateNextSVG} alt="next" />
          </button>
        </div>
      </div>
      <div className={classNames(styles.monthGrid, isTodoPicker ? styles.todoPickerMonthGrid : '')}>
        {months.map((month, index) => (
          <button
            key={index}
            className={classNames(
              styles.monthButton,
              {
                [styles.today]: isToday(index) && !isTodoPicker,
                [styles.focused]: !isToday(index) && isFocused(index) && !isTodoPicker,
                [styles.todoPickerToday]: isToday(index) && isTodoPicker,
                [styles.todoPickerFocused]: !isToday(index) && isFocused(index) && isTodoPicker,
              },
              isTodoPicker ? styles.todoPickerMonthButton : '',
            )}
            onClick={() => handleMonthClick(index)}
          >
            {month}
          </button>
        ))}
      </div>
      {showToday && (
        <div className={styles.footer}>
          <button
            className={classNames(
              styles.todayButton,
              isTodoPicker ? styles.todoPickerTodayButton : '',
            )}
            onClick={onTodayClick}
          >
            {t('calendar.edit.today')}
          </button>
        </div>
      )}
    </div>
  )
}

export default MonthPicker
